import { Container, Typography } from "@mui/material";
import { Grid, Box, Button } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import EuroIcon from "@mui/icons-material/Euro";
import Paper from "@mui/material/Paper";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { useStyles } from "./icon-info-card-styles";

export const IconInfoCard = (props) => {
  const classes = useStyles();

  return (
    <>
      <Paper className={classes.paper} variant="elevation" elevation={0} sx={
        {
          backgroundColor:props.themeColor 
          //props.themeColor
        }
      } >
        <Box className={classes.cardContentsWrapper}>
          <props.icon/>

          <Box className={classes.cardHeaderTextWrapper} >
            <Typography  className={classes.cardHeader}>
              {props.header}
            </Typography>

            <Typography className={classes.cardText}>
            {props.text}
            </Typography>
          </Box>

          <props.icon className={classes.secondBgIcon} />
         
        </Box>
      </Paper>
    </>
  );
};
